import React from "react";
import NumberFormat from "react-number-format";
import {
  Box,
  Flex,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
} from "@chakra-ui/core";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { animated } from "react-spring";
import { Error } from "../style";
import { ArrowDownIcon } from "@chakra-ui/icons";
import { emailRegEx } from "../../functions/index";

const ABox = animated(Box);

const KontaktPodaci = (props) => {
  const { style, state, control, errors, handleNext, handleSubmit } = props;

  return (
    <ABox style={style} pos="absolute" top={0}>
      <Flex flexWrap="wrap" mb={{ base: "3em", md: 0 }}>
        <Heading w="100%" mt="1em">
          Kontakt podaci
        </Heading>
        <Flex justifyContent="space-around" width="100%" flexWrap="wrap">
          <Box mt="1em" h="100px" w={{ base: "100%", md: 1 / 2 }} px="15px">
            <FormControl isRequired>
              <FormLabel color="black" htmlFor="imePrezime">
                Ime i prezime
              </FormLabel>
              <Controller
                as={Input}
                borderColor={
                  errors.hasOwnProperty("imePrezime") ? "red.500" : ""
                }
                control={control}
                color="black"
                name="imePrezime"
                placeholder="Ime i prezime"
                defaultValue={state.data.imePrezime}
                rules={{ required: "Ime i prezime je obvezno" }}
              />
            </FormControl>
            <ErrorMessage as={Error} errors={errors} name="imePrezime" />
          </Box>
          <Box mt="1em" h="100px" w={{ base: "100%", md: 1 / 2 }} px="15px">
            <FormControl isRequired>
              <FormLabel color="black" htmlFor="adresa">
                Adresa
              </FormLabel>
              <Controller
                as={Input}
                borderColor={errors.hasOwnProperty("adresa") ? "red.500" : ""}
                control={control}
                color="black"
                name="adresa"
                placeholder="Adresa"
                defaultValue={state.data.adresa}
                rules={{ required: "Adresa je obvezna" }}
              />
            </FormControl>
            <ErrorMessage as={Error} errors={errors} name="adresa" />
          </Box>
          <Box mt="1em" h="100px" w={{ base: "100%", md: 1 / 2 }} px="15px">
            <FormControl isRequired>
              <FormLabel color="black" htmlFor="telMob">
                Telefon/Mobitel
              </FormLabel>
              <Controller
                as={
                  <NumberFormat
                    allowLeadingZeros
                    decimalSeparator={false}
                    type="text"
                    customInput={Input}
                  ></NumberFormat>
                }
                borderColor={errors.hasOwnProperty("telMob") ? "red.500" : ""}
                control={control}
                color="black"
                name="telMob"
                placeholder="Telefon/Mobitel"
                defaultValue={state.data.telMob}
                rules={{ required: "Telefon/Mobitel je obvezan" }}
              />
            </FormControl>
            <ErrorMessage as={Error} errors={errors} name="telMob" />
          </Box>
          <Box mt="1em" h="100px" w={{ base: "100%", md: 1 / 2 }} px="15px">
            <FormControl isRequired>
              <FormLabel color="black" htmlFor="email">
                Email
              </FormLabel>
              <Controller
                as={Input}
                borderColor={errors.hasOwnProperty("email") ? "red.500" : ""}
                control={control}
                color="black"
                name="email"
                placeholder="Email"
                defaultValue={state.data.email}
                rules={{
                  required: "Email je obvezan",
                  pattern: {
                    value: emailRegEx,
                    message: "Email adresa nije ispravna",
                  },
                }}
              />
            </FormControl>
            <ErrorMessage as={Error} errors={errors} name="email" />
          </Box>
        </Flex>
      </Flex>
      <Flex
        d={{ base: "none", md: "flex" }}
        m="auto"
        mt="2em"
        maxW="600px"
        justifyContent="space-around"
        mb="2em"
      >
        <Button
          onClick={handleSubmit(handleNext)}
          colorScheme="green"
          boxShadow="-5px -5px green"
          border="0"
          _hover={{
            boxShadow: "0px 0px green",
            backgroundColor: "green.600",
            transform: "translateY(-5px)",
          }}
        >
          Nastavi
          <span>
            <ArrowDownIcon />
          </span>
        </Button>
      </Flex>
    </ABox>
  );
};

export default KontaktPodaci;
